export default __webpack_public_path__ + "static/media/login-title.0635d80b.webp";